import spbAdmin from './api/SpbAdminApi';
import supplierMasterApi from './api/SpbSupManApi';

class VendorListService {
	getSetting(userId, companyName) {
		const query = companyName
			? `?company=${encodeURIComponent(companyName)}`
			: '';
		return spbAdmin.get(`spb/vendorlist/getsetting/${userId}${query}`);
	}

	checkSnapAccess(userId, vendorId) {
		return supplierMasterApi.get(
			`vendorlist/snapaccess/${userId}?vendor_id=${vendorId}`
		);
	}

	save(payload) {
		return spbAdmin.post('spb/vendorlist/save', payload);
	}

	enterSnap(payload) {
		return supplierMasterApi.post('vendorlist/entersnap', payload);
	}

	submitPortal(payload) {
		return supplierMasterApi.post('vendorlist/submit', payload);
	}

	submit(payload) {
		return spbAdmin.post('spb/vendorlist/submit', payload);
	}
}

export default new VendorListService();
